import React, { useState } from "react";
import { Card } from "react-bootstrap";

import "./SkillsCard.css";
import SkillExperience from "../SkillExperience/SkillExperience";

const SkillsCard = (collaborator) => {
  const experienceLevels = {
      developer:
      [
        {
          title: "Muito Pouco: ",
          text: "Já fiz POCs com essa tecnologia a ponto de me sentir confortável para trabalhar em um projeto com ela, desde que acompanhado de um líder técnico com bastante domínio.",
        },
        {
          title: "Pouco: ",
          text: "Já participei de projetos com essa tecnologia, mas somente dando manutenção. Ainda preciso consultar bastante a documentação de algumas funcionalidades específicas.",
        },
        {
          title: "Médio: ",
          text: "Participei ativamente de mais de um projeto que, com sucesso, utilizou essa tecnologia. Tenho entendimento de sua arquitetura, seus pontos positivos, negativos e principais dificuldades.",
        },
        {
          title: "Bom: ",
          text: "Auxiliei a implementação do zero dessa tecnologia em mais de um projeto e teria capacidade de transmitir meu conhecimento para quem está começando com ela.",
        },
        {
          title: "Proficiente: ",
          text: "Conseguiria liderar a implementação dessa tecnologia em um projeto seguindo as mais importantes melhores práticas e padrões de projeto. Tenho confiança de que poderia ser um centro focal para resolução de problemas específicos que possam surgir.",
        },
      ],
      designer: [
        {
        title: "Muito Pouco: ",
        text: "Estou estudando mas não possuo experiência com a ferramenta.",
        },
        {
          title: "Pouco: ",
          text: "Não possuo experiência mas tenho uma noção básica do uso da ferramenta.",
        },
        {
          title: "Médio: ",
          text: "Possuo experiência, mas ainda tenho dificuldade com algumas funcionalidades da ferramenta.",
        },
        {
          title: "Bom: ",
          text: "Possuo experiência e conhecimento da ferramenta.",
        },
        {
          title: "Proficiente: ",
          text: "Tenho experiência ampla com a ferramenta e consigo ensinar outras pessoas a usarem a ferramenta.",
        },
      ],
      operations:
      [
        {
          title: "Muito Pouco: ",
          text: "Estou estudando mas não possuo experiência com a ferramenta.",
        },
        {
          title: "Pouco: ",
          text: "Tenho noção do seu uso, mas não trabalho com a ferramenta.",
        },
        {
          title: "Médio: ",
          text: "Possuo experiência, mas ainda tenho dificuldade com algumas features.",
        },
        {
          title: "Bom: ",
          text: "Tenho experiência e trabalho com a ferramenta com frequência.",
        },
        {
          title: "Proficiente: ",
          text: "Tenho experiência ampla com a ferramenta e consigo ensinar outras pessoas a usarem a ferramenta.",
        },
      ],
    };

    const getDescription = () => {
      switch(collaborator.team.id){
        case 1:
          return 'developer'
        case 2:
          return 'designer'
        case 3:
          return 'operations'
        default:
          return 'developer'
      }
     };

  const [stars, setStars] = useState(1);

  const handleOnHover = (event) => {
    if (event === undefined) {
      return;
    }

    setStars(event);
  };
  
  return (
    <Card>
      <Card.Body>
        <Card.Title>Habilidades Técnicas</Card.Title>
        <Card.Text>
          Esse é o registro de habilidades técnicas. Aqui vamos explicar como funciona a alocação de habilidades na
          página e qual é a importância desse preenchimento.
        </Card.Text>

        <div className="skill-experience-container pt-4">
          <SkillExperience stars={stars} starsSize={"big"} onHover={handleOnHover} />
        </div>

        <Card.Text className="pt-4">
            <span className="skill-experience-title">{experienceLevels[getDescription()][stars - 1]?.title}</span>
            {experienceLevels[getDescription()][stars - 1]?.text}
        </Card.Text>

        <Card.Text className="pt-4">
          O registro de habilidades é uma maneira pessoal sua de se avaliar, e também de ajudar você a encontrar novas
          skills pra se nivelar.
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default SkillsCard;
